/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1CourseregistrationSharedDocumentsListOfPerson200,
  GetApiV1CourseregistrationSharedDocumentsListOfPerson401,
  GetApiV1CourseregistrationSharedDocumentsListOfPerson500,
  GetApiV1CourseregistrationSharedDocumentsListOfPersonQueryParams,
  GetApiV1CourseregistrationSharedDocumentsListOfPersonQueryResponse,
} from "../../types/courseRegistrationSharedController/GetApiV1CourseregistrationSharedDocumentsListOfPerson.ts";
import { dropDownListViewModelSchema } from "../dropDownListViewModelSchema.ts";

export const getApiV1CourseregistrationSharedDocumentsListOfPersonQueryParamsSchema =
  z
    .object({
      personId: z.optional(z.coerce.number().int()),
      classStudentId: z.optional(z.coerce.number().int()),
    })
    .optional() as unknown as ToZod<GetApiV1CourseregistrationSharedDocumentsListOfPersonQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1CourseregistrationSharedDocumentsListOfPerson200Schema =
  z.array(
    z.lazy(() => dropDownListViewModelSchema),
  ) as unknown as ToZod<GetApiV1CourseregistrationSharedDocumentsListOfPerson200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1CourseregistrationSharedDocumentsListOfPerson401Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationSharedDocumentsListOfPerson401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1CourseregistrationSharedDocumentsListOfPerson500Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationSharedDocumentsListOfPerson500>;

export const getApiV1CourseregistrationSharedDocumentsListOfPersonQueryResponseSchema =
  z.lazy(
    () => getApiV1CourseregistrationSharedDocumentsListOfPerson200Schema,
  ) as unknown as ToZod<GetApiV1CourseregistrationSharedDocumentsListOfPersonQueryResponse>;
